import React, { useState } from 'react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';
import { TableCell, TableRow } from '../ui/table';
import { ChevronDown, ChevronRight, Link2, Star, Trash2 } from 'lucide-react';
import { BancoSponsorBadge, ReemplazadoBadge } from './CvuReemplazoInfo';
import { CvuWayaDetalle } from './CvuWayaDetalle';
import { cvuNumero, esCvuActivo } from './cvuUtils';

const estadoWayaCls = (estado) => {
  const e = (estado || '').toLowerCase();
  if (e.includes('bloqueado')) return 'bg-red-100 text-red-700';
  if (e.includes('activ') || e.includes('habilit')) return 'bg-green-50 text-green-700';
  return 'bg-slate-100 text-slate-600';
};

const ReemplazaCelda = ({ cvu, idx }) => (
  <TableCell className="text-xs" data-testid={`cvu-reemplaza-a-${idx}`}>
    {cvu.reemplaza_a ? (
      <div><span className="font-mono text-slate-700">{cvu.reemplaza_a}</span>{cvu.motivo_cambio && <p className="text-slate-500">{cvu.motivo_cambio}</p>}</div>
    ) : <span className="text-slate-400">—</span>}
    {cvu.reemplazado_por && <p className="text-slate-500">Reemplazado por <span className="font-mono">{cvu.reemplazado_por}</span></p>}
  </TableCell>
);

export const ClienteCvuFila = ({ cvu, idx, tipo, puedeBorrar, esAdmin, onToggleActivo, onSetPrincipal, onDelete, onVincular }) => {
  const [abierto, setAbierto] = useState(false);
  const numero = cvuNumero(cvu);
  const activo = esCvuActivo(cvu);
  const esPrincipal = tipo === 'PRINCIPAL';
  return (
    <>
      <TableRow className={activo ? '' : 'bg-slate-50/70'} data-testid={`cvu-row-${idx}`}>
        <TableCell className="w-8 p-2">
          <Button variant="ghost" size="sm" className="h-6 w-6 p-0" onClick={() => setAbierto(!abierto)} title="Ver datos Waya" data-testid={`cvu-expandir-${idx}`}>
            {abierto ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
          </Button>
        </TableCell>
        <TableCell>
          <div className="flex items-center gap-1.5">
            {esPrincipal && <Star size={13} className="text-amber-500 fill-amber-500 flex-shrink-0" />}
            <span className="font-mono text-xs font-medium text-slate-900" data-testid={`cvu-numero-${idx}`}>{numero}</span>
            <Badge className={`text-[10px] px-1.5 py-0 ${esPrincipal ? 'bg-amber-100 text-amber-800' : 'bg-slate-200 text-slate-600'}`}>{tipo}</Badge>
          </div>
        </TableCell>
        <TableCell><BancoSponsorBadge banco={cvu.banco_sponsor} testid={`cvu-sponsor-badge-${idx}`} /></TableCell>
        <TableCell>
          <div className="flex flex-wrap gap-1">
            <Badge className={`text-[10px] px-1.5 py-0 ${activo ? 'bg-green-100 text-green-700' : 'bg-slate-200 text-slate-500'}`} data-testid={`cvu-estado-${idx}`}>{activo ? 'Activo' : 'Inactivo'}</Badge>
            {cvu.estado && !['activo', 'inactivo'].includes(cvu.estado.toLowerCase()) && (
              <Badge className={`text-[10px] px-1.5 py-0 ${estadoWayaCls(cvu.estado)}`}>{cvu.estado}</Badge>
            )}
            <ReemplazadoBadge cvu={cvu} testid={`cvu-reemplazado-badge-${idx}`} />
          </div>
        </TableCell>
        <ReemplazaCelda cvu={cvu} idx={idx} />
        <TableCell className="text-xs text-slate-600" data-testid={`cvu-origen-${idx}`}>{cvu.origen_label || 'Padrón'}</TableCell>
        <TableCell className="text-xs text-slate-600">{cvu.alias || cvu.comentarios || '—'}</TableCell>
        <TableCell>
          <div className="flex items-center justify-end gap-1">
            <Switch checked={activo} onCheckedChange={() => onToggleActivo(numero, activo)} className="data-[state=checked]:bg-green-500 scale-90" data-testid={`cvu-toggle-activo-${idx}`} />
            {esAdmin && onVincular && (
              <Button variant="ghost" size="sm" onClick={() => onVincular(cvu)} title="Vincular reemplazo" className="h-7 w-7 p-0" data-testid={`cvu-vincular-reemplazo-${idx}`}>
                <Link2 size={13} className="text-indigo-500" />
              </Button>
            )}
            {!esPrincipal && (
              <Button variant="ghost" size="sm" onClick={() => onSetPrincipal(numero)} title="Marcar como principal" className="h-7 w-7 p-0" data-testid={`cvu-set-principal-${idx}`}>
                <Star size={13} className="text-amber-400" />
              </Button>
            )}
            {puedeBorrar && (
              <Button variant="ghost" size="sm" onClick={() => onDelete(numero)} title="Eliminar CVU" className="h-7 w-7 p-0" data-testid={`cvu-eliminar-${idx}`}>
                <Trash2 size={13} className="text-red-400" />
              </Button>
            )}
          </div>
        </TableCell>
      </TableRow>
      {abierto && (
        <TableRow>
          <TableCell colSpan={8} className="p-0"><CvuWayaDetalle cvu={cvu} idx={idx} /></TableCell>
        </TableRow>
      )}
    </>
  );
};
